// components/RslSuperAppBanner.jsx
/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Link from "next/link";
import { Box, Paper, Stack, Typography } from "@mui/material";
import shouldShowPlayStore from "../../utils/shouldShowPlayStore";

export default function RslSuperAppBanner({
    bg = "/images/bannerImage/rsl_super_app.svg",               // single background image
    title = "RSL SUPER APP",
    height = { xs: 140, sm: 260, md: 320, lg: 470, xl: 620 },                       // banner height
    radius = { xs: 3, md: 4 },                           // rounded corners
    appStore = { href: "https://apps.apple.com/in/app/rsl-car-booking-service/id1351219496", img: "/img/header/appstorefull.svg", alt: "Download on the App Store" },
    playStore = { href: "https://play.google.com/store/apps/details?id=com.rsl.luxurycab.passenger", img: "/img/header/playstorefull.svg", alt: "Get it on Google Play" },
}) {
    return (
        <Paper
            elevation={0}
            sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: radius,
                minHeight: height,
                bgcolor: "#0a0f14",
            }}
        >
            {/* Background image */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    "& img": {
                        objectFit: { xs: "contain", sm: "cover", md: "contain", lg: "cover" }, // xs=mobile, md+=desktop
                        objectPosition: "center",
                        width: "100%",
                        height: "100%",
                    },
                }}
            >
                <Image
                    src={`${process.env.IMAGE_BASE_URL}${bg}`}
                    alt={title}
                    fill
                    priority
                    sizes="(max-width: 900px) 100vw, 100vw"
                />
            </Box>


            {/* Title – top center */}
            <Box
                sx={{
                    position: "absolute",
                    top: { xs: 20, md: 28 },
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1,
                    px: 2,
                    textAlign: "center",
                    width: "100%"
                }}
            >
                <Typography
                    className="jura"
                    sx={{
                        color: "#EFFFFF",
                        fontWeight: 800,
                        letterSpacing: ".02em",
                        textShadow: "0 2px 10px rgba(0,0,0,.45)",
                        fontSize: { xs: 14, sm: 18, md: 36, lg: 44 },
                        lineHeight: 1.1,
                    }}
                >
                    {title}
                </Typography>
            </Box>

            {/* Badges – centered near bottom */}
            <Stack
                direction="row"
                spacing={{ xs: 1, md: 1.5, xl: 3 }}
                alignItems="center"
                sx={{
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    bottom: { xs: 18, md: 26 },
                    zIndex: 1,
                }}
            >
                <Link href={appStore.href} aria-label={appStore.alt}>
                    <Box sx={{ position: "relative", width: { xs: 45, sm: 80, md: 115, lg: 138, xl: 190 }, height: { xs: 15, sm: 30, md: 45, lg: 48, xl: 70 } }}>
                        <Image src={appStore.img} alt={appStore.alt} fill style={{ objectFit: "contain", borderRadius: "10px", background: "white" }} />
                    </Box>
                </Link>
                {
                    shouldShowPlayStore() && (
                        <Link href={playStore.href} aria-label={playStore.alt}>
                            <Box sx={{ position: "relative", width: { xs: 45, sm: 80, md: 115, lg: 138, xl: 190 }, height: { xs: 15, sm: 30, md: 45, lg: 48, xl: 70 } }}>
                                <Image src={playStore.img} alt={playStore.alt} fill style={{ objectFit: "contain", borderRadius: "10px", background: "white" }} />
                            </Box>
                        </Link>)
                }
            </Stack>
        </Paper>
    );
}
